import { gql } from "@apollo/client";

/**
 * 根据Tab查询异常单列表
 */
export const QUERY_EXCEPTION_ORDERS_BY_TAB = gql`
    query QueryExceptionOrdersByTab(
        $warehouseId: Long!
        $filters: ExceptionOrderFiltersTypeInput
    ) {
        queryExceptionOrdersByTab(warehouseId: $warehouseId, filters: $filters) {
            items {
                id
                orderId
                trackingNumber
                exceptionReasonCode
                exceptionPriority
                nextAction
                exceptionStatus
                parcelStatus
                markExceptionAt
                putawayAt
                pickingAt
                markExceptionOperator
                orderStatus
                recipientAddress {
                    addressLine1
                    addressLine2
                    city
                    state
                    zipcode
                }
                recipientPostalCode
                deliveryAttempts
                currentWarehouseId
                clientName
                hubName
                warehouseName
                dspName
                driverName
                markExceptionOperatorName
                warehouseLocationCode
                storageNumber
                returnToWhsAt
                putawayDays
                isOverdue
                createdAt
                updatedAt
            }
            totalCount
            pageNumber
            pageSize
            totalPages
        }
    }
`;


/**
 * 按需查询指定Tab的计数（新接口）
 */
export const QUERY_EXCEPTION_ORDER_COUNTS_BY_TABS = gql`
    query QueryExceptionOrderCountsByTabs(
        $warehouseId: Long!
        $filters: ExceptionOrderCountFiltersTypeInput!
        $tabs: [String!]!
    ) {
        queryExceptionOrderCountsByTabs(warehouseId: $warehouseId, filters: $filters, tabs: $tabs) {
            tab
            count
        }
    }
`;

